import InsightReportViewModel from "./InsightReportViewModel";

export default class InsightReportTableViewModel {
    public reports: InsightReportViewModel[] = []
    public resultCount: number = 0;
    public pageCount: number = 1;
}